import React from 'react';
import UrlTo from '../../../../../url-to';
import { t } from '../../../../../i18n';
import { ButtonLink } from '../../../../../components';
import {
  cameraIcon,
  circleTickIcon,
  clockIcon,
  giftCardIcon,
  keyIcon,
  pdfIcon,
  shoppingCartIcon,
  scribbleZigzagPriceImage,
} from '../../../../assets';
import { formatCoursePrice } from '../../../../utilities';
import classNames from 'classnames';
import './styles.scss';

const PriceAndSummaryBlock = ({
  courseId,
  price,
  hoursTotal,
  lessonsTotal,
  downloadableMaterialsAreAvailable,
  courseIsPurchased,
  courseIsStarted,
  className,
}) => {
  const getCourseButtonText = () => {
    if (courseIsStarted) return t('DIGITAL_COURSES.CONTINUE_COURSE');
    if (courseIsPurchased) return t('DIGITAL_COURSES.START_COURSE');
    return (
      <span>
        <img src={shoppingCartIcon} alt="shopping-cart" />
        {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_COURSE')}
      </span>
    );
  };

  const showDiscount = price.isDiscountApplied && !courseIsPurchased;

  return (
    <div className={classNames('specific-course-screen__price-block', className)}>
      {!showDiscount && (
        <div className="specific-course-screen__price-block-price">
          <h2>{formatCoursePrice(price)}</h2>
          {courseIsPurchased && (
            <div className="specific-course-screen__price-block-purchased">
              <img src={circleTickIcon} alt="Purchased" />
              <span>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.PRICE_AND_SUMMARY.PURCHASED_COURSE_TITLE')}</span>
            </div>
          )}
        </div>
      )}
      {showDiscount && (
        <div className="specific-course-screen__price-block-discount-price">
          <strong className="specific-course-screen__price-block-discount-price-old">
            {formatCoursePrice({ amount: price.originalAmount, currency: price.currency })}
            <img src={scribbleZigzagPriceImage} alt="Old price" />
          </strong>
          <strong className="specific-course-screen__price-block-discount-price-new">{formatCoursePrice(price)}</strong>
        </div>
      )}
      <ButtonLink
        href={courseIsPurchased ? UrlTo.coursesWatchLesson(courseId) : UrlTo.coursesCheckout(courseId)}
        type="green"
        className="specific-course-screen__price-block-purchase-button"
        text={getCourseButtonText()}
      />
      <ButtonLink
        href={UrlTo.coursesGiftCardCheckout()}
        type="white"
        className="specific-course-screen__price-block-purchase-button"
        text={
          <span>
            <img src={giftCardIcon} alt="Gift card" />
            {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_GIFT_CARD')}
          </span>
        }
      />
      <ButtonLink
        href={UrlTo.coursesGiftCardRedeem({ courseId })}
        type="white"
        className="specific-course-screen__price-block-purchase-button"
        text={
          <span>
            <img src={keyIcon} alt="Code" />
            {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.ACTIVATE_GIFT_CARD')}
          </span>
        }
      />
      <div className="specific-course-screen__price-block-summary">
        <div className="specific-course-screen__price-block-course-hours">
          <img src={clockIcon} alt="hours" />
          <span>{`${hoursTotal} ${t('DIGITAL_COURSES.HOURS')}`}</span>
        </div>
        {lessonsTotal > 1 && (
          <div className="specific-course-screen__price-block-course-lessons-number">
            <img src={cameraIcon} alt="lessons-number" />
            <span>{`${lessonsTotal} ${t('DIGITAL_COURSES.LESSONS')}`}</span>
          </div>
        )}
        {downloadableMaterialsAreAvailable && (
          <div className="specific-course-screen__price-block-course-attachments">
            <img src={pdfIcon} alt="attachments" />
            <span>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.PRICE_AND_SUMMARY.INCLUDING_ATTACHMENTS')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceAndSummaryBlock;
